import Comparation from "./Comparation.Container";

export default Comparation;